import Matter from 'matter-js';
import { AnimationControls } from 'framer-motion';

import COLORS from '~/constants/colors';

import { Dim, Entity } from '../../models';
import { INPUT_MODES } from '../../../../../../constants/defaults';
import {
  posOf,
  getNoteDims,
  getReceptorDims,
  getReceptorY,
} from '../../helpers';
import Feedback from '../renderers/Feedback';

export default (
  windowDims: Dim,
  inputMode: string,
  rating: 'CORRECT' | 'PERFECT',
  animate: AnimationControls,
  ratingColor = COLORS.gold,
  statColor = COLORS.white
): Entity => {
  const noteDims = getNoteDims(windowDims);
  const receptorDims = getReceptorDims(windowDims);
  const receptorY = getReceptorY(windowDims, receptorDims, inputMode);
  const receptorEdge = receptorDims.w / 2 + 2 * (receptorDims.b ?? 0);
  const bounder = rating === 'CORRECT' ? Math.max : Math.min;
  const scaler1 = rating === 'CORRECT' ? 1 : 3;
  const scaler2 = rating === 'CORRECT' ? -1 : 1;
  const scaler3 = inputMode === INPUT_MODES.jog ? 0 : 1 / 2;
  const pos = {
    x: bounder(
      scaler1 * (windowDims.w / 4) + scaler2 * scaler3 * receptorEdge,
      windowDims.w / 2 + scaler2 * 1.07 * receptorDims.w
    ),
    y: receptorY - 2.5 * receptorDims.h,
  };
  const feedbackDims = {
    w: 2 * noteDims.w,
    h: 1.23 * noteDims.h,
  };
  const body = Matter.Bodies.rectangle(
    pos.x,
    pos.y,
    feedbackDims.w,
    feedbackDims.h,
    { type: 'feedback' }
  );

  return {
    dims: feedbackDims,
    getPos: () => posOf(body),
    body,
    rating,
    stat: 0,
    animate,
    ratingColor,
    statColor,
    renderer: Feedback,
  };
};
